import apiClient from './client';

// --- PARENT AUTH & MANAGEMENT ---

// Register a new parent
export const registerParent = (data) => apiClient.post('/auth/register-parent', data);

// Login (Works for both Parent and Student)
export const login = (credentials) => apiClient.post('/auth/login', credentials);
export const loginAsStudent = (student) => apiClient.post('/auth/login-as-student', student);
export const googleLogin = (credential) => apiClient.post('/auth/google-login', { credential });
export const requestPasswordReset = (email) => apiClient.post('/auth/reset-password', { email });
export const verifyResetToken = (token) => apiClient.get(`/auth/verify-reset-token?token=${token}`);
export const updatePassword = (token, newPassword) => apiClient.post('/auth/update-password', { token, newPassword });

// Create a student account (Parent must be logged in)
export const createStudent = (studentData) => apiClient.post('/parent/create-student', studentData);

// Fetch students linked to the logged-in parent
export const getMyStudents = () => apiClient.get('/parent/my-students');


// --- STUDENT CONTENT ---

export const fetchGrades = () => apiClient.get('/parent/grades');
export const fetchSubjects = (gradeId) => apiClient.get(`/student/subjects/${gradeId}`);
export const fetchCurriculum = () => apiClient.get('/student/curriculum');
export const fetchStudentProfile = () => apiClient.get('/student/profile');
export const fetchChildProfile = (studentId) => apiClient.get(`/parent/student/${studentId}`);
export const fetchQuizQuestions = (topicId) => apiClient.get(`/quizzes/quiz/topic/${topicId}`);
export const submitQuizAttempt = async (payload) => {
    // payload will contain: userId, topicId, responses, totalTimeSeconds
    return await apiClient.post('/quizzes/quiz/submit', payload);
};
export const downloadCertificate = (attemptId) => apiClient.get(`/quizzes/quiz/certificate/${attemptId}`, { responseType: 'blob' });

export const fetchStudentLearningJourney = (studentId) => apiClient.get(`/quizzes/quiz/history/${studentId}`);
export const fetchStudentProgressMetrics = () => apiClient.get('/student/progress-metrics');

export const fetchGlobalLeaderboard = () => apiClient.get('/student/leaderboard');
export const fetchNewLeaderboard = () => apiClient.get('/student/leaderboards');
export const fetchStudentProfileBadges = () => apiClient.get('/student/achievements')

// --- NEWSLETTER ---

export const subscribeToNewsletter = (email) => apiClient.post('/admin/subscribe', { email });

// --- Curriculum Data ---
export const getCurriculumData = () => apiClient.get('utils/curriculum_data');

// --- Printables ---
export const getPublicPrintables = (params) => apiClient.get('printables', { params });
export const getPrintablesMetaOptions = () => apiClient.get('printables/meta-options');
export const trackPrintableDownload = (id) => apiClient.post(`printables/${id}/download`);

// --- Challenge 20K ---
export const startChallenge20K = () => apiClient.get('/challenge20/start');
export const completeChallenge20K = (payload) => apiClient.post('/challenge20/complete', payload);